<script>
import storageService from "@/services/storage";
import Popin from "@/components/molecules/popin";
import Icon from "@/components/atoms/icon";
import Button from "@/components/atoms/button";

export default {
  name: "PopinProduitNonExistant",
  components: {
    Popin,
    Icon,
    Button
  },
  props: {
    shopName: {
      type: String,
      required: false,
      default: ""
    }
  },
  emits: ["changeMagasin"],
  data() {
    return {
      isChangeShopAction: false
    };
  },
  methods: {
    hidePopin() {
      storageService.delete("__cora_product_id__");
      this.$refs.popin.hide();
    },
    changeMagasin() {
      this.isChangeShopAction = true;
      this.$emit("changeMagasin");
      this.$refs.popin.hide();
    }
  }
};
</script>

<template>
  <Popin
    ref="popin"
    v-bind="removeClassAndStyleFromAttrs($attrs)"
    aria-label="Produit indisponible"
    size="lg"
    @closed="isChangeShopAction ? $refs.popin.hide() : hidePopin()"
  >
    <div class="u-text-center u-font-15">
      <div class="c-popin-confirmation-magasin__title u-mb-sm">
        <Icon
          name="shop"
          size="xxlg"
        />
        <Icon
          name="alert-circle"
          variant="primary"
          size="sm"
          class="c-popin-confirmation-magasin__title-icon"
        />
      </div>

      <p>
        Ce produit a été supprimé de votre panier car il n'est pas disponible dans le magasin de {{ shopName }}.
      </p>
      <div class="u-inline-flex u-mt-md u-flex-column-reverse@md">
        <Button
          variant="primary"
          outline
          radius="full"
          size="md"
          class="u-mr-sm u-mr-none@md"
          @click="changeMagasin()"
        >
          Je change de magasin
        </Button>
        <Button
          variant="primary"
          radius="full"
          size="md"
          class="u-ml-md u-ml-none@md u-mb-sm@md"
          @click="hidePopin()"
        >
          Je consulte les offres dans ce magasin
        </Button>
      </div>
    </div>
  </Popin>
</template>

<style lang="scss" scoped>
.c-popin-confirmation-magasin__title {
  position: relative;
  display: inline-block;
}
.c-popin-confirmation-magasin__title-icon {
  position: absolute;
  bottom: 2px;
  right: 0px;
  background-color: #fff;
  border-radius: 100%;
}
</style>
